import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VobAssignmentView } from '../../services/profileService/model/profile/VobAssignmentView';

interface VobAssignmentEditModalState {
    modalOpen: boolean;
    assignment: VobAssignmentView | null;
}

interface ProfileModuleState{
    centerAccessModal:boolean;
    claimAccessModal:boolean;
    lookupUserModal:boolean;
    vobAssignmentAddModal:boolean;
    vobAssignmentBulkImportModal:boolean;
    vobAssignmentEditModal: VobAssignmentEditModalState;
}

const initialState:ProfileModuleState={centerAccessModal:false, claimAccessModal:false, lookupUserModal:false, vobAssignmentAddModal:false, vobAssignmentBulkImportModal:false, vobAssignmentEditModal: { modalOpen: false, assignment: null }}
export const profileModuleSlice = createSlice({
    name:'ProfileModule',
    initialState,
    reducers:{
        toggleCenterAccessModal:(state) =>{
            state.centerAccessModal = !state.centerAccessModal;
        },
        toggleClaimAccessModal:(state)=>{
            state.claimAccessModal = !state.claimAccessModal;
        },
        toggleLookupUserModal:(state) =>{
            state.lookupUserModal = !state.lookupUserModal;
        },
        toggleVobAssignmentAddModal:(state) =>{
            state.vobAssignmentAddModal = !state.vobAssignmentAddModal;
        },
        toggleVobAssignmentBulkImportModal:(state) =>{
            state.vobAssignmentBulkImportModal = !state.vobAssignmentBulkImportModal;
        },
        openVobAssignmentEditModal:(state, action: PayloadAction<VobAssignmentView>) =>{
            state.vobAssignmentEditModal.modalOpen = true;
            state.vobAssignmentEditModal.assignment = action.payload;
        },
        closeVobAssignmentEditModal:(state) =>{
            state.vobAssignmentEditModal.modalOpen = false;
            state.vobAssignmentEditModal.assignment = null;
        }
    }
})

export const {toggleCenterAccessModal, toggleClaimAccessModal, toggleLookupUserModal, toggleVobAssignmentAddModal, toggleVobAssignmentBulkImportModal, openVobAssignmentEditModal, closeVobAssignmentEditModal} = profileModuleSlice.actions;
export default profileModuleSlice.reducer;